export const UPLOAD_IMAGE_LEFT = 'imageMorpher/UPLOAD_IMAGE_LEFT';
export const UPLOAD_IMAGE_RIGHT = 'imageMorpher/UPLOAD_IMAGE_RIGHT';
export const START_MORPH = 'imageMorpher/START_MORPH';
export const MORPH_SUCCESS = 'imageMorpher/MORPH_SUCCESS';
export const MORPH_FAILURE = 'imageMorpher/MORPH_FAILURE';
